import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiTrendingUp, FiFileText, FiSettings } from 'react-icons/fi';

const Sidebar = () => {
  const navItems = [
    { path: '/dashboard', icon: FiHome, label: '대시보드' },
    { path: '/trades', icon: FiTrendingUp, label: '거래 내역' },
    { path: '/logs', icon: FiFileText, label: '시스템 로그' },
    { path: '/settings', icon: FiSettings, label: '설정' },
  ];

  return (
    <aside className="hidden md:block w-60 bg-gray-800 border-r border-gray-700 fixed left-0 top-14 sm:top-16 bottom-0 z-30">
      <nav className="p-4 space-y-2">
        {navItems.map((item) => (
          item.disabled ? (
            <div
              key={item.path}
              className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-600 cursor-not-allowed"
            >
              <item.icon className="text-xl" />
              <span>{item.label}</span>
            </div>
          ) : (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-gray-700 text-blue-500 border-l-4 border-blue-500'
                    : 'text-gray-400 hover:bg-gray-700 hover:text-white'
                }`
              }
            >
              <item.icon className="text-xl" />
              <span>{item.label}</span>
            </NavLink>
          )
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
